
// Import your custom SVG icons
import RemoteServiceIcon from './icons/remote-service.svg';
import InsightIcon from './icons/insight.svg';
import DesignIcon from './icons/design.svg';
import CogIcon from './icons/cog.svg';

import {
  VideojetConnectDesign,
  VideojetConnectDesignNew,
  VideojetConnectExchange,
  VideojetConnectInsight,
  VideojetConnectRemoteService,
} from './constants/global';
import { ReactNode } from "react";


interface INavigationItem {
  title: string;
  segment?: string;
  icon?: ReactNode;
  children?: INavigationItem[];
  hidden?: boolean;
  siteModule?: string;
  extraModule?: string;
  hideIfModuleNotEnabled?: boolean;
  hideIfNotEnabled?: boolean;
  showAlways?: boolean;
  requireAdmin?: boolean;
  requireSite?: boolean;
  kind?: string;
}

const standardVrsModules = { siteModule: 'vrs', extraModule: 'vrsOperations', hideIfModuleNotEnabled: true, hideIfNotEnabled: true };
const standardInsightModules = { siteModule: 'Intelligence', hideIfModuleNotEnabled: true, hideIfNotEnabled: true };
const standardApiModules = { siteModule: 'api', hideIfModuleNotEnabled: true, hideIfNotEnabled: true };


export const getBaseNavigation = (_T, selectedSiteId, isAdmin, isUserConfigImporter, canUserAccessNewDesign): INavigationItem[] => [
  {
    title: VideojetConnectRemoteService,
    segment: 'vrs',
    showAlways: true,
    icon: <img src={RemoteServiceIcon} alt="Remote Service" style={{ width: 20, height: 20 }} />, // Replace with custom icon
    children: [
      { ...standardVrsModules, title: _T('Summary'), segment: 'summary' },
      { ...standardVrsModules, title: _T('Site Dashboard'), segment: 'sitedashboard' },
      { ...standardVrsModules, title: _T('Site Map'), segment: 'sitemap' },
      { ...standardVrsModules, title: _T('Availability'), segment: 'availability' },
      { ...standardVrsModules, title: _T('Production'), segment: 'production' },
      { ...standardVrsModules, title: _T('Service Dashboard'), segment: 'servicedashboard' },
      {
        title: _T('Reports'), segment: 'reports',
        children: [
          { ...standardVrsModules, title: _T('Printer Snapshot'), segment: 'snapshot' },
          { ...standardVrsModules, title: _T('Printer Performance'), segment: 'performance' },
          { ...standardVrsModules, title: _T('Data Download'), segment: 'datadownload' },
          { ...standardVrsModules, title: _T('Rapid Recovery'), segment: 'rapidrecovery' },
          { ...standardVrsModules, title: _T('Consumable Usage'), segment: 'consumables' },
          { ...standardVrsModules, title: _T('Printer Needing Attention'), segment: 'unitrequiringattention' },
          { ...standardVrsModules, title: _T('VRS Usage'), segment: 'usage' },
        ],
      },
    ],
  },

  {
    title: VideojetConnectInsight,
    segment: 'insight',
    siteModule: 'Intelligence',
    icon: <img src={InsightIcon} alt="Insight" style={{ width: 20, height: 20 }} />, // Replace with custom icon
    children: [
      { ...standardInsightModules, title: _T('Performance'), segment: `site/${selectedSiteId}/lines/overview` },
      { ...standardInsightModules, title: _T('Reports'), segment: `site/${selectedSiteId}/report/oee` },
    ],
  },
  {
    title: VideojetConnectDesign,
    segment: 'design',
    siteModule: 'Design',
    icon: <img src={DesignIcon} alt="Design" style={{ width: 20, height: 20 }} />, 
  },
  {
    title: VideojetConnectDesignNew,
    segment: 'new-design',
    // siteModule: 'Design',
    icon: <img src={DesignIcon} alt="Design New" style={{ width: 20, height: 20 }} />, 
    hidden: !(isAdmin || isUserConfigImporter || canUserAccessNewDesign),
  },
  {
    title: _T("Configuration"),
    segment: 'configuration',
    icon: <img src={CogIcon} alt="Configuration" style={{ width: 20, height: 20 }} />,
    children: [
      {
        title: _T('Remote Service'),
        segment: 'remoteservice',
        ...standardVrsModules,
        children: [
          { ...standardVrsModules, title: _T('Users'), segment: 'users' },
          { ...standardVrsModules, title: _T('Favorites'), segment: 'favorites' },
          { ...standardVrsModules, title: _T('Companies'), segment: 'companymanagement' },
          { ...standardVrsModules, title: _T('Sites'), segment: 'sitemanagement' },
          { ...standardVrsModules, title: _T("RES's"), segment: 'resmanagement' },
          { ...standardVrsModules, title: _T('Devices'), segment: 'devicemanagement' },
          { ...standardVrsModules, title: _T('Alerts'), segment: 'alertmanagement' },
          { ...standardVrsModules, title: _T('Notification Logs'), segment: 'notificationlog' },
          { ...standardVrsModules, title: _T('Data Tags'), segment: 'datatags' },
          { ...standardVrsModules, title: _T('Events'), segment: 'events' },
          { ...standardVrsModules, title: _T('SF Articles'), segment: 'salesforcearticles' },
          { ...standardVrsModules, title: _T('Device Logs'), segment: 'logmanagement' },
          { ...standardVrsModules, title: _T('Site Tags'), segment: 'sitetags' },
          { ...standardVrsModules, title: _T('Work Schedule'), segment: 'workschedule' },
        ],
      },
      {
        title: _T('Insight'),
        segment: 'insight',
        ...standardInsightModules,
        children: [
          { ...standardInsightModules, title: _T('Sites'), segment: 'sites' },
          { ...standardInsightModules, title: _T('Lines'), segment: `site/${selectedSiteId}/lines` },
          { ...standardInsightModules, title: _T('Products'), segment: `site/${selectedSiteId}/products` },
          { ...standardInsightModules, title: _T('Shifts'), segment: `site/${selectedSiteId}/shifts` },
          { ...standardInsightModules, title: _T('Downtimes'), segment: `site/${selectedSiteId}/downtimes/category` },
          { ...standardInsightModules, title: _T('Display Mode'), segment: `site/${selectedSiteId}/displaymode` },
          { ...standardInsightModules, title: _T('Roles'), segment: `site/${selectedSiteId}/roles` },
          { ...standardInsightModules, title: _T('UserAccess'), segment: 'company/users' },
        ],
      },
      {
        title: VideojetConnectExchange,
        segment: 'api',
        siteModule: 'api',
        children: [
          { ...standardApiModules, title: _T('Getting Started'), segment: 'gettingstarted' },
          { ...standardApiModules, title: _T('REST API Explorer'), segment: 'explorer' },
        ],
      },
      {
        title: _T('Design'),
        segment: 'design',
        siteModule: 'Design',
        hidden: !(isAdmin || isUserConfigImporter || canUserAccessNewDesign),
        children: [
          { title: _T('Manage Logos'), segment: 'logos', siteModule: 'Design' },
          { title: _T('Manage Settings'), segment: 'settings', siteModule: 'Design' },
          { title: _T('Subscriptions'), segment: 'subscriptions', siteModule: 'Design' },
        ],
      },
      {
        title: _T('Administrator'),
        segment: 'admin',
        requireAdmin: true,
        hidden: !isAdmin,
        children: [
          {
            requireAdmin: true,
            requireSite: true,
            title: _T('Admin Site Configuration'),
            segment: `site/${selectedSiteId}/properties`,
          },
          {
            requireAdmin: true,
            title: _T('Manage Translations'), segment: 'translations',
          },
          {
            requireAdmin: true,
            title: _T('Operations'),
            segment: 'operations',
          },
        ],
      },
    ],
  },

];
